import Base from 'records/Base';
import FileSaver from 'file-saver';
import {
  PDF_DOWNLOAD_START,
  PDF_DOWNLOAD_ERROR,
  PDF_DOWNLOAD_RECIPE_CARD_SUCCESS,
  PDF_EXTERNAL_ASYNC_SUCCESS,
  EXCEL_DOWNLOAD_START,
  EXCEL_DOWNLOAD_ERROR,
  EXCEL_DOWNLOAD_MENU_SUCCESS,
  LABOR_COST_CALCULATOR_DOWNLOAD_SUCCESS,
  WORD_DOWNLOAD_START,
  WORD_DOWNLOAD_ERROR,
  WORD_DOWNLOAD_MENU_SUCCESS,
} from 'actions/pdf';

const initialState = new Base({
  loading: false,
  errorMessage: null,
});

const actionsMap = {
  [PDF_DOWNLOAD_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [PDF_DOWNLOAD_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [PDF_DOWNLOAD_RECIPE_CARD_SUCCESS]: (state, action) => {
    const output = new File([action.data], `${ action.recipeName } Card.pdf`, { type: 'application/pdf' });
    FileSaver.saveAs(output);
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [PDF_EXTERNAL_ASYNC_SUCCESS]: (state, action) => {
    const output = new File([action.data], `${ action.fileName }.pdf`, { type: 'application/pdf' });
    FileSaver.saveAs(output);
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [EXCEL_DOWNLOAD_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [EXCEL_DOWNLOAD_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [EXCEL_DOWNLOAD_MENU_SUCCESS]: (state, action) => {
    const output = new File([action.data], `${ action.menuName }.xlsx`, { type: 'application/ms-excel' });
    FileSaver.saveAs(output);
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [LABOR_COST_CALCULATOR_DOWNLOAD_SUCCESS]: (state, action) => {
    const output = new File([action.data], 'Labor Cost Calculator.xlsx', { type: 'application/ms-excel' });
    FileSaver.saveAs(output);
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [WORD_DOWNLOAD_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [WORD_DOWNLOAD_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [WORD_DOWNLOAD_MENU_SUCCESS]: (state, action) => {
    const output = new File([action.payload.data], `${ action.payload.menuName }.docx`, { type: 'application/ms-word' });
    FileSaver.saveAs(output);
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
};

export default function pdf(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
